import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {style} from "variables/Variables.jsx";
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/datatables/responsive.dataTables.min.css";
import SimpleReactValidator from "simple-react-validator";
import NotificationSystem from "react-notification-system";
import {Button, FormGroup, Input, Label} from "reactstrap";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class EditQuery extends Component{
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.svalidator = new SimpleReactValidator();
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            loading: false,
            query: '',
            queryType: '',
            isSubmit:false,
            userType: '',
            _notificationSystem: null,
            status: '',
            displayQrName: '',
            values: [],
            queryElements: [],
            checkedItems: [],
            versions: [],
            output_versions: [],
            versionType: [],
            selectedOutputVersion:'',
            newVersion:'',
            prevQuery:'',
            userID:''
        }

    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            userType:decoded.userType
        });
        axios.get(config.get('API_URL')+'/sqlbuilder/getQuery/'+this.props.match.params.id).then(response => {
            let qrName;
            let displayQrName;
            let queryTitle;
            let queryVersionTitle;
            var queyStr = JSON.parse(response.data[0].extraData).queryArgs;

            if(response.data[0].dataStore=='api-studio' || response.data[0].queryType=='noSQL')
            {
                qrName = JSON.parse(response.data[0].extraData).defaultQuery;
            }
            else{
                qrName = response.data[0].query;
            }
            if(response.data[0].dataStore=='api-studio' && response.data[0].queryType=='SQL'){
                displayQrName = JSON.parse(response.data[0].extraData).defaultQuery;
                this._extractAllText(displayQrName);
            }
            else{
                displayQrName = response.data[0].query;
            }
            if(response.data[0].dataStore=='data-pipeline'){
                queryTitle='Pipeline Name';
                queryVersionTitle='Analytx Store Version';
            }
            else if(response.data[0].dataStore=='data-modeler') {
                queryTitle='Modeler Name';
                queryVersionTitle='Object Store Version'
            }
            else{
                queryTitle='Studio Name';
                queryVersionTitle='Api Store Version'
            }

            this.setState({
                id: response.data[0].id,
                queryName: response.data[0].tableName,
                status: response.data[0].status,
                def_query: response.data[0].query,
                query:qrName,
                displayQrName: displayQrName,
                prevQuery: displayQrName,
                selectedVersion: response.data[0].inputVersion,
                selectedOutputVersion: response.data[0].outputVersion,
                versionType: response.data[0].dataStore,
                queryType: response.data[0].queryType,
                userID: response.data[0].userID,
                queryVersionTitle: queryVersionTitle,
                queryTitle: queryTitle
            });
            if(this.state.queryType == 'noSQL' || this.state.versionType == 'api-studio') {
                Object.keys(queyStr).forEach(function (k, i) {
                    this.setState({
                        checkedItems: {...this.state.checkedItems, [k]: true},
                        values: {...this.state.values, [k]: queyStr[k]}
                    })
                }.bind(this));
                console.log("ppp");
                console.log(this.state.checkedItems);
                console.log(this.state.values);
            }

            this._output_version(this);
        });
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;

    }
    _output_version() {
        axios.get(config.get('API_URL')+'/users/allversions/',{
            params: {
                pageType: this.state.versionType
            }
        }).then(response => { console.log("ddd"); console.log(response);

            this.setState({
                output_versions: response.data,
            })
        });
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    _extractAllText(str){
        const re = /'(.*?)'/g;
        var arr = str.match(re);
        //var arr = JSON.stringify (arr);
        if(arr!=null) {
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].replace(/'/g, "");
            }
            console.log(arr);
            arr = [...new Set(arr)];
            this.setState({
                queryElements: arr
            })
        }
    }

    onSubmit(e) {
        e.preventDefault();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        if(this.state.versionType=='api-studio' && this.state.queryType=='SQL'){
            this._extractAllText(this.state.displayQrName);
        }
        else{
            this.setState({
                queryElements: []
            })
        }
        this.setState({
            loading: true
        });
        if(this.state.prevQuery != this.state.displayQrName) {
            this.setState({
                checkedItems: {},
                values: {}
            })
        }
        if ($.fn.DataTable.isDataTable('#queryBuilderTable')) {
            $('#queryBuilderTable').DataTable().clear().destroy();
            $('#queryBuilderTable').html('');
        }
        const data = {
            query: this.state.displayQrName,
            modelVersion: this.state.selectedVersion,
            type: this.state.versionType,
            queryType: this.state.queryType,
        };
        axios.post(config.get('API_URL')+'/sqlbuilder/sqlBuilder', data, {
            headers: {
                Authorization: ` ${token}`
            }
        })
            .then(response => {
                if (response.data.error) {
                    console.log("error");
                    this.setState({
                        errors: response.data.error
                    })
                } else {
                    console.log("sucessss");
                    console.log(response.data);
                    this.setState({
                        chartData :response.data.data,
                        isSubmit:true,
                        loading: true
                    });
                    if(this.state.queryType=='noSQL'){
                        this.setState({
                            query:response.data.sql_query
                        })
                    }

                    const tableHeaders = [];
                    const exampleRecord = response.data.data[0];
                    const keys = Object.keys(exampleRecord);
                    console.log(keys);
                    keys.forEach(function(k) {
                        tableHeaders.push({
                            sTitle: k,
                            mData: k.replace(/\./g,'\\.')
                            //optionally do some type detection here for render function
                        });
                    });
                    console.log(tableHeaders);
                    //const header = tableHeaders
                    $('#queryBuilderTable').DataTable({
                        "bProcessing": true,
                        "aaData": response.data.data,
                        "aoColumns": tableHeaders,
                        responsive: true,
                        mark:true
                    });
                    this.setState({
                        loading: false
                    })

                }
            })
            .catch(err => {
                console.log(err);
            })
    }
    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    toggleSaveQueryModel() {
        this.svalidator.hideMessages();
        this.setState({
            saveQueryModel: !this.state.saveQueryModel
        })
    }
    changeVersion(e){
        if(e.target.value!='new'){
            this.setState({
                newVersion:''
            })
        }
        this.setState({
            selectedOutputVersion: e.target.value
        })
    }
    editQuery() {
        if (this.svalidator.allValid()) {
            let versionName;
            let isNew;
            if(this.state.newVersion==''){
                versionName = this.state.selectedOutputVersion;
                isNew = false;
            }
            else{
                versionName = this.state.newVersion;
                isNew = true;
            }
            const queryData = {
                query: this.state.query,
                version: this.state.selectedVersion,
                isNew: isNew,
                output_version: versionName,
                queryName: this.state.queryName,
                versionType: this.state.versionType,
                extraData: this.state.values,
                queryType: this.state.queryType,
                createdBy: this.state.userID
            };
            console.log(queryData);
            axios.post(config.get('API_URL')+'/sqlbuilder/saveSqlQuery/', queryData).then(response => {
                console.log(response);
                if(response.data.code==200) {
                    this.handleNotificationClick("tr", 1, "Query has been successfully Added.");
                    this.setState({
                        saveQueryModel: false,
                        query: '',
                        queryName: '',
                        values: [],
                        checkedItems: [],
                        version: versionName,
                        isSubmit: false,
                        newVersion: '',
                        selectedVersion: this.state.selectedVersionAdd,
                        output_version: this.state.output_versionAdd
                    });
                    this.svalidator.hideMessages();
                    $('#queryBuilderTable').DataTable().clear().destroy();
                    $('#queryBuilderTable').html('');

                }
                else if(response.data.code==409){
                    this.handleNotificationClick("tr", 3, "Name Conflict");
                }
                else {
                    this.handleNotificationClick("tr", 3, "Error");
                }

            });
        } else {
            this.svalidator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }

    editApiQuery() {
        var dfquery;
        var s = this.state.displayQrName;

        if(this.state.queryType=='SQL') {
             dfquery = this.state.displayQrName;
        }
        else{
            dfquery = this.state.query;
        }

        this.setState({
            defautQuery:s
        });
        var valuestr = this.state.values;
        Object.keys(valuestr).forEach(function(k) {
            var replceSrt = "#"+valuestr[k];
            s = s.replace(new RegExp("'"+k+"'","g"), replceSrt)
        });
        var newTemp = s;
        this.setState({
            query: newTemp
        });


        if (this.svalidator.allValid()) {
            let versionName;
            let isNew;
            let newVersionName;
            if(this.state.newVersion==''){
                versionName = this.state.selectedOutputVersion;
                isNew = false;
            }
            else{
                versionName = this.state.newVersion;
                isNew = true;
                newVersionName = this.state.newVersion;
            }
            var exData = {"queryArgs": this.state.values, "defaultQuery": dfquery, "isNewVersion": isNew, "newVersionName": newVersionName};
            const queryData = {
                query: newTemp,
                id: this.state.id,
                version: this.state.selectedVersion,
                isNew: isNew,
                output_version: versionName,
                queryName: this.state.queryName,
                versionType: 'api-studio',
                extraData: exData,
                queryType: this.state.queryType,
                createdBy: this.state.userID
            };

            console.log(queryData);
            if(this.state.newVersion!='') {
                const newVersionData = {
                    name: this.state.newVersion,
                    type: 'api-studio',
                    userID: this.state.userID
                };
                axios.post(config.get('API_URL')+'/users/addversion/', newVersionData).then(response => {
                    console.log(response);
                    if (response.data.error) {
                        console.log(response.data.error);
                    } else {
                        console.log("added")
                    }
                });
            }
            axios.put('/sqlbuilder/editApiQuery/', queryData).then(response => {
                console.log(response);
                if (response.data.error) {
                    this.handleNotificationClick("tr", 3, response.data.error);
                } else {
                    this.handleNotificationClick("tr", 1, "Query has been successfully Updated.");
                    this.setState({
                        saveQueryModel: false,
                        // query: '',
                        // queryName: '',
                        // values: [],
                        // checkedItems: [],
                        // version: versionName,
                        // isSubmit: false,
                        // newVersion: '',
                        // selectedVersion: this.state.selectedVersionAdd,
                        // output_version: this.state.output_versionAdd
                    });

                    this.svalidator.hideMessages();
                    // $('#queryBuilderTable').DataTable().clear().destroy();
                    // $('#queryBuilderTable').html('');

                }
            });
        } else {
            this.svalidator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }
    handleChange(i,e) {
        this.setState({
            values: {...this.state.values, [i]: e.target.value },
        });
        // console.log(this.state.checkedItems)

    }
    handleChangea(i,e) {

        const item = e.target.name;
        const isChecked = e.target.checked;
        this.setState({
            checkedItems: {...this.state.checkedItems, [i]:isChecked}
        });
        if(isChecked === false){
            //this.state.values.splice(i,1)
            //_.omit(this.state.values,item);
            delete this.state.values[item];
        }

        console.log(this.state.checkedItems)
    }
    render(){
        console.log("hghg");
        console.log(this.state.checkedItems);
        console.log(this.state.values);
        let tableIcons = null;
        if(this.state.isSubmit === true){
            tableIcons = (
                <React.Fragment>
                    <a href="#" className="approve-query-icon" role="button"  onClick={this.toggleSaveQueryModel.bind(this)} >
                        <i className="fa fa-edit"></i> Edit
                    </a>
                </React.Fragment>
            );
        }
        let versions = this.state.output_versions.map((version,index) => {
            return (
                <option value={version.name} key={index+1}>{version.name}</option>
            )
        });
        var fieldsArray = [];
        let queryElements = this.state.queryElements.map((parameter,index) => {
            let chk;
            if(this.state.checkedItems[parameter]==true) {
                chk = "checked";
            }
            else {
                chk = "";
            }
            //alert(chh);

            fieldsArray.push(
                <div key={index+1}>
                    <div className="col-md-3 col-xs-6">
                        <label className="checkboxcontainer">{parameter}
                            <input type="checkbox" name={parameter} checked={chk}
                                   onChange={this.handleChangea.bind(this, parameter)} />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <div className="col-md-9 col-xs-6">
                        <label>
                            { this.state.checkedItems[parameter]===true ?
                                <input
                                    type='text'
                                    value={this.state.values[parameter]}
                                    name={parameter}
                                    className="form-control"
                                    onChange={this.handleChange.bind(this, parameter)} />
                                : null }
                        </label>
                    </div>
                    <div className="clearfix"></div>
                </div>
            );
        });
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <div className="header query-builder">
                                    <h4 className="title">{this.state.queryName}</h4>
                                    <p className="category"></p>
                                </div>


                                    <div className="row tab-content">
                                        <div className="col-md-8 col-md-border-right">
                                            <form className="" method="POST" onSubmit={this.onSubmit}>
                                                <div className="padd15">
                                                    <div className="form-group">
                                                    <textarea rows="3" name = "displayQrName" placeholder="select * from Test.test_table limit 10" id="formControlsTextarea"
                                                     className="form-control queyEditor" value={this.state.displayQrName} onChange={this.onChange}></textarea>
                                                        {this.validator.message('query', this.state.query, 'required')}
                                                    </div>
                                                    <button type="submit" className="btn btn-primary pull-right">Preview Result</button>
                                                    <br/>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="padd15">
                                                <div className="save_editor_form">
                                                    <div className="col-md-12">
                                                        <FormGroup>
                                                            <Label for="queryName">{this.state.queryTitle}</Label>
                                                            <Input  name="queryName" id="queryName" value={this.state.queryName}  onChange={this.onChange} disabled="disabled"/>
                                                            {this.svalidator.message('queryName', this.state.queryName, 'required')}
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Label for="Version">{this.state.queryVersionTitle}</Label>
                                                            <select name="version" className="form-control" value={this.state.selectedOutputVersion} onChange={this.changeVersion.bind(this)} disabled="disabled">
                                                                {versions}
                                                                <option value="new">New</option>
                                                            </select>
                                                        </FormGroup>
                                                        { this.state.selectedOutputVersion=='new' ?
                                                            <FormGroup>
                                                                <Label for="newVersion">New Version</Label>
                                                                <Input  name="newVersion" id="newVersion" value={this.state.newVersion}  onChange={this.onChange}/>
                                                            </FormGroup>
                                                            : null }
                                                    </div>
                                                    {fieldsArray}
                                                    <div className="clearfix"></div>
                                                </div>
                                                <div className="col-md-12 actions">
                                                    {this.state.versionType=='api-studio' ?
                                                            <Button color="btn btn-primary pull-right mar15" onClick={this.editApiQuery.bind(this)}>Save Api</Button>:
                                                            <Button color="btn btn-primary pull-right mar15" onClick={this.editQuery.bind(this)}>Save</Button>
                                                    }
                                                    {' '}
                                                </div>
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>
                                    {/*{  tableIcons }*/}



                                {/*<Modal isOpen={this.state.saveQueryModel} toggle={this.toggleSaveQueryModel.bind(this)} >*/}
                                {/*    <ModalHeader toggle={this.toggleSaveQueryModel.bind(this)}>Edit Query</ModalHeader>*/}
                                {/*    <ModalBody>*/}
                                {/*        <div className="col-md-12">*/}
                                {/*            <FormGroup>*/}
                                {/*                <Label for="queryName">Pipeline Name</Label>*/}
                                {/*                <Input  name="queryName" id="queryName" value={this.state.queryName}  onChange={this.onChange} disabled="disabled"/>*/}
                                {/*                {this.svalidator.message('queryName', this.state.queryName, 'required')}*/}
                                {/*            </FormGroup>*/}
                                {/*            <FormGroup>*/}
                                {/*                <Label for="Version">Analytx Store Version</Label>*/}
                                {/*                <select name="version" className="form-control" value={this.state.selectedOutputVersion} onChange={this.changeVersion.bind(this)} disabled="disabled">*/}
                                {/*                    {versions}*/}
                                {/*                    <option value="new">New</option>*/}
                                {/*                </select>*/}
                                {/*            </FormGroup>*/}
                                {/*            { this.state.selectedOutputVersion=='new' ?*/}
                                {/*                <FormGroup>*/}
                                {/*                    <Label for="newVersion">New Version</Label>*/}
                                {/*                    <Input  name="newVersion" id="newVersion" value={this.state.newVersion}  onChange={this.onChange}/>*/}
                                {/*                </FormGroup>*/}
                                {/*                : null }*/}
                                {/*        </div>*/}
                                {/*        {fieldsArray}*/}
                                {/*        <div className="clearfix"></div>*/}
                                {/*    </ModalBody>*/}
                                {/*    <ModalFooter>*/}
                                {/*        {this.state.versionType=='api-studio' ?*/}
                                {/*        <Button color="primary" onClick={this.editApiQuery.bind(this)}>Save Api</Button>:*/}
                                {/*        <Button color="primary" onClick={this.editQuery.bind(this)}>Save</Button>*/}
                                {/*        }*/}
                                {/*        {' '}*/}
                                {/*        <Button color="secondary" onClick={this.toggleSaveQueryModel.bind(this)}>Cancel</Button>*/}
                                {/*    </ModalFooter>*/}
                                {/*</Modal>*/}

                                <div className='sweet-loading'>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </div>
                                <p>&nbsp;</p>
                                <div className="content table-full-width table-responsive">
                                    <table className="table table-striped table-hover" id="queryBuilderTable">
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default EditQuery;